
(function () {
    'use strict';

    angular.module(modules.homeModule)
           .controller(controllers.personChapterConfirmsSumsListController, personChapterConfirmsSumsListController);

    personChapterConfirmsSumsListController.$inject = ['$scope', '$http'];

    function personChapterConfirmsSumsListController($scope, $http) {
        var vm = this;
        vm.initialize = initialize;

        function initialize() {
        };
    };
})();

